import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';

export const LayoutContext = React.createContext();

function LayoutProvider({ children }) {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [showHover, setShowHover] = React.useState(false);
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down('lg'), {
    noSsr: true,
  });

  React.useEffect(() => {
    if (isTablet) {
      setIsExpanded(false);
    } else {
      setIsExpanded(true);
    }
  }, [isTablet]);

  const value = React.useMemo(() => {
    return {
      isExpanded,
      setIsExpanded,
      setShowHover,
      showHover,
    };
  }, [[isExpanded, setIsExpanded, setShowHover, showHover]]);

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
}

LayoutProvider.propTypes = {
  children: PropTypes.node,
};

LayoutProvider.defaultProps = {
  children: null,
};

export default LayoutProvider;
